<mat-sidenav-container>
  <mat-sidenav [opened]="isSidenavOpen" mode="side" role="navigation">
    <div class="mat-sidenav-wrapper">
      <div class="mat-nav-wrapper">
        <!-- Grouped nav items -->
        @for (group of navGroups; track group) {
          <div class="group-label">{{ (navLabelKeys[group.label] ?? group.label) | transloco }}</div>
          <mat-nav-list class="nav-group">
            @for (item of group.items; track item) {
              <a
                [routerLink]="item.link"
                class="inactiveRow"
                routerLinkActive="activeRow"
                [attr.data-testid]="'side-menu-option-' + item.label.replaceAll(' ', '-').toLowerCase()">
                <div class="list-item" matRipple>
                  <span class="list-item-icon" routerLinkActive="activeIcon">
                    <mat-icon>{{ item.icon }}</mat-icon>
                  </span>
                  <span
                    class="list-item-label"
                    routerLinkActive="activeText"
                    [matBadge]="getBadgeValue(item.label)"
                    matBadgeSize="small"
                    matBadgeOverlap="false"
                    [matBadgeHidden]="shouldHideBadge(item.label)">
                    {{ (navLabelKeys[item.label] ?? item.label) | transloco }}
                  </span>
                </div>
              </a>
            }
          </mat-nav-list>
        }
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="spacer-small"></div>
    <div toastContainer aria-live="polite"></div>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>